(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/services/assets/actions/teams-actions.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/services/assets/actions/teams-actions.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _RTK = RTK,
  createAsyncThunk = _RTK.createAsyncThunk,
  createAction = _RTK.createAction;
const jupiter = svs.core.jupiter;
const FetchState = svs.components.marketplaceCompetition.constants.FetchState;
const normalizePersonalResults = svs.components.marketplaceCompetition.services.helpers.normalizePersonalResults;
const _svs$components$marke = svs.components.marketplaceCompetition.services.selectors,
  selectTeams = _svs$components$marke.selectTeams,
  selectTeamResult = _svs$components$marke.selectTeamResult;
const isAnonymous = svs.core.session.data.userSession.isAnonymous;
const competitionHandler = svs.components.marketplaceCompetition.competitionHandler.competitionHandler;
const fetchTeamsCondition = (competitionId, _ref) => {
  let getState = _ref.getState;
  if (!competitionId) {
    return false;
  }
  if (isAnonymous) {
    return false;
  }
  const state = getState();
  const _selectTeams = selectTeams(state, competitionId),
    status = _selectTeams.status,
    lastFetched = _selectTeams.lastFetched;
  if (status === FetchState.Pending || new Date(lastFetched).getTime() + 5000 > Date.now()) {
    return false;
  }
};
const fetchTeams = createAsyncThunk('fetchTeams', competitionId => competitionHandler().fetchPlayerCompetitionTeams(competitionId), {
  condition: fetchTeamsCondition
});
const leaveTeam = createAsyncThunk('leaveTeam', async _ref2 => {
  let competitionId = _ref2.competitionId,
    teamId = _ref2.teamId,
    customerId = _ref2.customerId;
  const _await$jupiter$callAs = await jupiter.callAsync({
      method: 'DELETE',
      path: "/competition/2/competitions/".concat(competitionId, "/teamInvitations?&teamId=").concat(teamId, "&customerId=").concat(customerId)
    }),
    response = _await$jupiter$callAs.response;
  return response;
});
const deleteTeam = createAsyncThunk('deleteTeam', async _ref3 => {
  let competitionId = _ref3.competitionId,
    teamId = _ref3.teamId;
  const _await$jupiter$callAs2 = await jupiter.callAsync({
      method: 'DELETE',
      path: "/competition/2/competitions/".concat(competitionId, "/teams?teamId=").concat(teamId)
    }),
    response = _await$jupiter$callAs2.response;
  return response;
});
const fetchTeamResult = createAsyncThunk('competition/fetchTeamResults', async _ref4 => {
  let competitionId = _ref4.competitionId,
    teamId = _ref4.teamId;
  const response = await competitionHandler().fetchPlayerCompetitionResults(competitionId, [teamId]);
  const _normalizePersonalRes = normalizePersonalResults(response),
    _normalizePersonalRes2 = _slicedToArray(_normalizePersonalRes, 2),
    individualResult = _normalizePersonalRes2[0],
    teamsResult = _normalizePersonalRes2[1];
  return [individualResult, teamsResult];
}, {
  condition: (_ref5, _ref6) => {
    let competitionId = _ref5.competitionId,
      teamId = _ref5.teamId;
    let getState = _ref6.getState;
    if (!competitionId) {
      return false;
    }
    if (isAnonymous) {
      return false;
    }
    if (!teamId) {
      return false;
    }
    const state = getState();
    const _selectTeamResult = selectTeamResult(state, competitionId, teamId),
      status = _selectTeamResult.status,
      lastFetch = _selectTeamResult.lastFetch;
    if (status === FetchState.Pending || new Date(lastFetch).getTime() + 5000 > Date.now()) {
      return false;
    }
  }
});
const joinTeamByInvitation = createAsyncThunk('invitation/join', async (_ref7, _ref8) => {
  let competitionId = _ref7.competitionId,
    teamId = _ref7.teamId,
    invitationId = _ref7.invitationId;
  let rejectWithValue = _ref8.rejectWithValue;
  try {
    const response = await svs.components.marketplaceShared.invitation.join(competitionId, teamId, invitationId);
    return response;
  } catch (err) {
    return rejectWithValue(err);
  }
});
const patchTeamResultAction = createAction('competition/patchTeamResult');
setGlobal('svs.components.marketplaceCompetition.services.actions.teamsActions', {
  fetchTeams,
  fetchTeamResult,
  leaveTeam,
  deleteTeam,
  joinTeamByInvitation,
  patchTeamResultAction
});

 })(window);